/* eslint-disable */
import Mustache from 'mustache'

function renderMustache(template, values) {
  return Mustache.render(template, values)
}

export default renderMustache
/* eslint-enable */
